<template>
  <div class="kj-join_list">
    <div class="kj-join_list-head">
      <span class="kj-join_list-title">帮砍榜单</span>
      <button class="kj-join_list-btn" @click="showChange">活动说明</button>
    </div>
    <Nodata v-if="!participatorList.length"></Nodata>
    <yd-infinitescroll :on-infinite="loadList" ref="infinitescrollDemo" v-else>
      <!-- 插入数据列表 -->
      <div class="kj-join_list-items" slot="list">
        <div class="kj-join_list-item" v-for="(item, index) in participatorList" :key="item.nickname">
          <div class="kj-join_list-item_avator">
            <img v-if="item.img" :src="item.img">
            <img v-else src="./noavatar.png">
          </div>
          <div class="kj-join_list-item_cont">
            <div class="kj-join_list-item_name">{{ item.nickname }}</div>
            <div class="kj-join_list-item_time">{{ item.time | formatDate }}</div>
          </div>
          <div class="kj-join_list-item_price">-￥{{(item.bargain_amount/100).toFixed(2)}}</div>
        </div>
      </div>
      <!-- 数据全部加载完毕显示 -->
      <span slot="doneTip">啦啦啦，啦啦啦，没有数据啦~~</span>
      <!-- 加载中提示 -->
      <img slot="loadingTip" src="./loading.svg" />
    </yd-infinitescroll>
  </div>
</template>
 <script>
  import Nodata from 'base/noData'
  import {bargainRecords} from 'api/bargainRecords'
  import {formatDate} from 'common/util/formatDate'

  export default {
    data () {
      return {
        participatorList: []
      }
    },
    props: ['player', 'id'],
    methods: {
      showChange () {
        this.$emit('isShow', true)
      },
      loadList () {
        this.$refs.infinitescrollDemo.$emit('ydui.infinitescroll.finishLoad')
      }
    },
    watch: {
      //   当playid改变时，重新拉取帮砍表单数据
      id: function () {
        if (!this.id) {
          return
        }
        bargainRecords(this.id).then((data) => {
          let bargainInf = data.data
          for (const item of bargainInf) {
            let participator = {
              img: '',
              nickname: '',
              time: '',
              bargain_amount: 0
            }
            participator.img = item.avatar
            participator.nickname = item.nick_name
            participator.time = item.created_at
            participator.bargain_amount = item.bargain_amount
            this.participatorList.push(participator)
          }
        })
      }
    },
    filters: {
      formatDate (date) {
        date = new Date(date)
        return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
      }
    },
    created () {
      if (!this.player || !this.player.playId) {
        return
      }
      console.log('this.player.playId', this.player.playId)
      bargainRecords(this.player.playId).then((data) => {
        let bargainInf = data.data
        for (const item of bargainInf) {
          let participator = {
            img: '',
            nickname: '',
            time: '',
            bargain_amount: 0
          }
          participator.img = item.avatar
          participator.nickname = item.nick_name
          participator.time = item.created_at
          participator.bargain_amount = item.bargain_amount
          this.participatorList.push(participator)
        }
      })
    },
    components: {
      Nodata
    }
  }
</script>

<style scoped>
  .kj-join_list-head {
    display: flex;
    line-height: 1;
  }
  .kj-join_list-title {
    flex: 1;
    margin: auto;
    font-size: 24px;
  }
  .kj-join_list-btn {
    outline: none;
    margin: auto auto 0;
    padding: 0;
    border: none;
    background: transparent;
    color: #179eff;
    font-size: 15px;
  }
  .kj-join_list-item {
    display: flex;
    padding: 20px 0;
    line-height: 1;
    border: 0 solid #ddd;
    border-width: 0 0 .5px;
  }
  .kj-join_list-item_avator {
    display: flex;
    width: 35px;
    height: 35px;
  }
  .kj-join_list-item_avator img {
    display: block;
    margin: auto;
    max-width: 100%;
    max-height: 100%;
    border-radius: 4px;
  }
  .kj-join_list-item_cont {
    flex: 1;
    margin: auto auto auto 10px;
    font-size: 14px;
  }
  .kj-join_list-item_name {
    margin: 0 0 5px;
    color: #555;
  }
  .kj-join_list-item_time {
    color: #999;
  }
  .kj-join_list-item_price {
    margin: auto;
    color: #ff4444;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// index.vue?6ca2f967